
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $51eea432ddae4add$exports = {};
$51eea432ddae4add$exports = import.meta.resolve("8movE");


var $9119536185ce4039$exports = {};
$9119536185ce4039$exports = import.meta.resolve("8UQBN");


const $51b1f58fe8be9ecc$var$trackCaseStudyDownloadUrl = "https://g4lw7xoavl.execute-api.ap-south-1.amazonaws.com/contact-prod/case-study-download";
// ── Data ─────────────────────────────────────────────────────────────────────
const $51b1f58fe8be9ecc$var$caseStudies = [
    {
        id: 'cs-1',
        category: 'Real Estate',
        categorySlug: 'real-estate',
        title: 'How BNY and Swirepay accelerate settlement and improve operational efficiency',
        description: "Swirepay worked with BNY to help real estate organizations digitize their disbursements and introduce real-time speed, while also streamlining reconciliation, gaining not only real-time payment confirmation and remittance visibility but an improvement to overall productivity.",
        keyResult: 'Reduced turnaround times by 3 days',
        company: 'Bank of New York',
        docYear: '',
        outcome: '90% reduction in vendor payout times',
        // img: 'https://www.swirepay.com/get-paid-faster.ac354ca4.png',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($9119536185ce4039$exports))),
        url: '#',
        pdfUrl: (0, (/*@__PURE__*/$parcel$interopDefault($51eea432ddae4add$exports)))
    }
];
function $51b1f58fe8be9ecc$export$7a0f33e8df10bd94() {
    const seen = new Set();
    return $51b1f58fe8be9ecc$var$caseStudies.map(function(s) {
        return {
            label: s.category,
            slug: s.categorySlug
        };
    }).filter(function(c) {
        if (seen.has(c.slug)) return false;
        seen.add(c.slug);
        return true;
    });
}
function $51b1f58fe8be9ecc$export$6a1d8c44c4f4815c(categorySlug) {
    if (!categorySlug || categorySlug === 'all') return $51b1f58fe8be9ecc$var$caseStudies;
    return $51b1f58fe8be9ecc$var$caseStudies.filter(function(s) {
        return s.categorySlug === categorySlug;
    });
}
// ── Renderers ─────────────────────────────────────────────────────────────────
function $51b1f58fe8be9ecc$var$buildCardHtml(study) {
    return `
    <div class="col-12 col-md-6 col-lg-4 cs-card-col" data-industry="${study.categorySlug}">
      <button type="button" class="cs-card" aria-label="View case study for ${study.company}" id="outcome-${study.id}">
        <div class="cs-card__img-wrap">
          ${study.img ? `<img src="${study.img}" alt="${study.company}" class="cs-card__img" />` : `<div class="cs-card__img-placeholder"></div>`}
          <div class="cs-card__badges">
            <span class="cs-card__badge cs-card__badge--industry">${study.category}</span>
          </div>
        </div>
        <div class="cs-card__body">
          <h3 class="cs-card__title">
            ${study.title}
          </h3>
          <p class="cs-card__desc">${study.description}</p>
          <div class="cs-card__result">
            <span class="cs-card__result-label">KEY RESULT</span>
            <p class="cs-card__result-value">${study.keyResult}</p>
          </div>
          <div class="cs-card__footer">
            <span class="cs-card__company">${study.company}</span>
            <span class="cs-card__doc-btn">
              <span class="cs-card__outcome">${study.outcome}</span>
              <span class="cs-card__doc">
                <i data-lucide="file-text" class="cs-card__doc-icon"></i>
                PDF ${study.docYear}
                <i data-lucide="arrow-up-right" class="cs-card__doc-arrow"></i>
              </span>
            </span>
          </div>
        </div>
      </button>
    </div>
  `;
}
function $51b1f58fe8be9ecc$var$renderCards(studies) {
    $('#cs-cards-container').html(studies.map($51b1f58fe8be9ecc$var$buildCardHtml).join(''));
    lucide.createIcons();
}
function $51b1f58fe8be9ecc$var$renderFilters() {
    var $tabs = $('.cs-filters__tabs');
    $tabs.empty();
    $tabs.append($('<button>', {
        class: 'cs-filters__tab cs-filters__tab--active',
        'data-filter': 'all',
        role: 'tab',
        'aria-selected': 'true',
        text: 'All'
    }));
    $51b1f58fe8be9ecc$export$7a0f33e8df10bd94().forEach(function(cat) {
        $tabs.append($('<button>', {
            class: 'cs-filters__tab',
            'data-filter': cat.slug,
            role: 'tab',
            'aria-selected': 'false',
            text: cat.label
        }));
    });
    $tabs.on('click', '.cs-filters__tab', function() {
        $tabs.find('.cs-filters__tab').removeClass('cs-filters__tab--active').attr('aria-selected', 'false');
        $(this).addClass('cs-filters__tab--active').attr('aria-selected', 'true');
        $51b1f58fe8be9ecc$var$renderCards($51b1f58fe8be9ecc$export$6a1d8c44c4f4815c($(this).data('filter')));
    });
}
// ── PDF Modal ─────────────────────────────────────────────────────────────────
const $51b1f58fe8be9ecc$var$studyById = Object.fromEntries($51b1f58fe8be9ecc$var$caseStudies.map(function(s) {
    return [
        s.id,
        s
    ];
}));
var $51b1f58fe8be9ecc$var$activeStudy = null;
function $51b1f58fe8be9ecc$var$openPdfModal(study) {
    var $modal = $('#cs-pdf-modal');
    $51b1f58fe8be9ecc$var$activeStudy = study;
    $('#cs-pdf-modal-meta').text(study.category);
    $('#cs-pdf-modal-title').text(study.title);
    $('#cs-pdf-modal-result-value').text(study.keyResult);
    $('#cs-pdf-modal-result-company').text(study.company);
    $('.cs-pdf-modal__banner-img').attr('src', study.img);
    $('#cs-pdf-email').val('');
    $('#cs-pdf-email-error-msg').text('');
    $modal.removeAttr('hidden');
    document.body.style.overflow = 'hidden';
    $('#cs-pdf-modal-close').trigger('focus');
}
function $51b1f58fe8be9ecc$var$closePdfModal() {
    $('#cs-pdf-modal').attr('hidden', '');
    document.body.style.overflow = '';
    $51b1f58fe8be9ecc$var$activeStudy = null;
}
function $51b1f58fe8be9ecc$var$isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
function $51b1f58fe8be9ecc$var$downloadCaseStudyPdf(study) {
    var $link = $('<a>', {
        href: study.pdfUrl,
        download: study.title + '.pdf'
    }).appendTo('body');
    $link[0].click();
    $link.remove();
}
function $51b1f58fe8be9ecc$var$handlePdfDownloadClick() {
    if (!$51b1f58fe8be9ecc$var$activeStudy) return;
    var email = $('#cs-pdf-email').val().trim();
    if (!email || !$51b1f58fe8be9ecc$var$isValidEmail(email)) {
        $('#cs-pdf-email-error-msg').text('Enter a valid email address (e.g. name@company.com).');
        return;
    }
    $('#cs-pdf-email-error-msg').text('');
    var payload = {
        payloadType: 'SWIREPAY_CASE_STUDY_PDF_DOWNLOAD',
        email: email,
        caseStudyTitle: $51b1f58fe8be9ecc$var$activeStudy.title
    };
    fetch($51b1f58fe8be9ecc$var$trackCaseStudyDownloadUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    }).catch(function() {});
    $51b1f58fe8be9ecc$var$downloadCaseStudyPdf($51b1f58fe8be9ecc$var$activeStudy);
    $51b1f58fe8be9ecc$var$closePdfModal();
}
// ── Init ──────────────────────────────────────────────────────────────────────
$(document).ready(function() {
    $51b1f58fe8be9ecc$var$renderFilters();
    $51b1f58fe8be9ecc$var$renderCards($51b1f58fe8be9ecc$export$6a1d8c44c4f4815c('all'));
    // Card click — delegate so it works after re-renders
    $('#cs-cards-container').on('click', '.cs-card', function() {
        var id = $(this).attr('id').replace('outcome-', '');
        var study = $51b1f58fe8be9ecc$var$studyById[id];
        if (study) $51b1f58fe8be9ecc$var$openPdfModal(study);
    });
    // Download PDF — validate email, submit, then download and close
    $('#cs-pdf-modal-download').on('click', $51b1f58fe8be9ecc$var$handlePdfDownloadClick);
    // Close via button or backdrop
    $(document).on('click', '#cs-pdf-modal-close, .cs-pdf-modal__backdrop', $51b1f58fe8be9ecc$var$closePdfModal);
    // Close on Escape
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && !$('#cs-pdf-modal').attr('hidden')) $51b1f58fe8be9ecc$var$closePdfModal();
    });
});


//# sourceMappingURL=case-studies.bfdabc9b.js.map
